import React, { Component } from 'react';
import PrintRecordPanel from '../containers/print-record-panel';


export default class PrintRecordContent extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
            <div style={{padding: '0 80px', display: 'flex',  justifyContent: 'center'}}>
                <PrintRecordPanel />
            </div>
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/print-record-content.js